import 'dayjs/locale/zh-cn'

import dayjs from 'dayjs'
import { AnimatePresence, motion } from 'framer-motion'
import MD5 from 'md5'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { BsBellFill, BsEmojiDizzy } from 'react-icons/bs'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { getLastCourse } from '@/api/center'
import picEmpty from '@/assets/images/pic_empty.png'
import Comment from '@/components/Comment'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import Modal from '@/components/Modal'
import { centerStore, useRecoilValue, useSetRecoilState } from '@/store'
dayjs.locale('zh-cn')
const { userState } = centerStore

const LESSONTYPE = {
  1: '正式课',
  0: '试听课'
}

export default function Index() {
  const [classState, setClassState] = useState(false)
  const [course, setCourse] = useState<any>({})
  const user = useRecoilValue(userState)

  const { isFetching, data } = useQuery(['getLastCourse', user.id], (props) => {
    const timestamp = (Date.now() / 1000).toFixed(0)
    if (props.queryKey[1]) {
      return getLastCourse({
        userId: props.queryKey[1],
        sign: MD5(`userId=${props.queryKey[1]}&timestamp=${timestamp}&key=${import.meta.env.VITE_APP_userSecretKey}`),
        timestamp
      })
    }
  })

  useEffect(() => {
    if (data && data.status === 0) {
      if (!Array.isArray(data.data)) {
        setCourse(data.data)
      }
    }
  }, [data])

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="flex justify-center items-start relative">
      <Loadding state={isFetching}>
        {course.id ? (
          <Fragment>
            <div className="w-[150px] h-[150px] rounded overflow-hidden">
              <ImgPlaceholder className="w-full h-full rounded anim_btn2 duration-300" src={course.cover} alt="" />
            </div>
            <div className="flex justify-between items-start flex-col flex-1 ml-[20px] h-[150px]">
              <div className="text-[16px] text-[#333]">
                时间:
                <span className="ml-[10px] text-[#666]">
                  {course.overseasOpen
                    ? `${dayjs(course.datetime * 1000).format('YYYY年MM月DD日 dddd HH:mm')} -
                  ${dayjs(course.datetime * 1000 + 3600000).format('HH:mm')}`
                    : course.date
                      ? `${course.date} ${course.week} ${course.hour}`
                      : null}
                </span>
              </div>
              <div className="text-[16px] text-[#333]">
                课程:<span className="ml-[10px] text-[#666]">{course.title}</span>
              </div>
              <div className="text-[16px] text-[#333]">
                老师:<span className="ml-[10px] text-[#666]">{course.teacherName}</span>
              </div>
              <div className="text-[16px] text-[#333]">
                状态:<span className="ml-[10px] text-[#666]">{course.lessonStatus}</span>
              </div>
              <button
                onClick={() =>
                  course.testReportUrl
                    ? // ? setClassState(true)
                      toast.success('请前往APP查看老师点评~')
                    : toast('老师未点评', { icon: <BsBellFill className="text-[#ff3300]" /> })
                }
                className={`${course.testReportUrl ? '' : 'opacity-[0.5]'} rounded-full px-[36px] py-[9px] text-[#ff3300] bg-[#ffeee8] border-[#ff3300] border-[1px] border-solid anim_btn2`}
              >
                查看点评
              </button>
            </div>
            <div>
              <button className={`${course.lessonType === 0 ? ' text-[#ffb500] bg-[#fff5dc]' : ' text-[#ff3300] bg-[#ffeee8]'} rounded w-[80px] h-[30px] flex items-center justify-center`}>
                {LESSONTYPE[course.lessonType] || '正式课'}
              </button>
            </div>
          </Fragment>
        ) : (
          <div className="w-full h-full flex items-center justify-center flex-col">
            <ImgPlaceholder className="w-[100px]" src={picEmpty} />
            <span className="text-[14px] text-[#999]">暂无数据</span>
          </div>
        )}
      </Loadding>
      <Modal show={classState} cancel={() => setClassState(false)} header="" cancelText="好的" className="class-modal">
        <Comment lessonId={course.id} />
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 30px;
  background-color: #fff;
  border-radius: 6px;
  .class-modal {
    width: 500px;
    padding: 0 0 20px 0;
    border-radius: 0;
  }
`
